import { initPrCarouselSwiper } from './helpers/initSwiper';

document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('.pr-carousel-advanced');
  if (!roots.length) return;

  roots.forEach((root) => {
    const raw = root.getAttribute('data-pr-carousel-options');
    if (!raw) return;

    let opts = {};
    try { 
      opts = JSON.parse(raw);
    } catch {
      return; 
    }

    // inner swiper lives inside the track wrapper
    const inner =
      root.querySelector('.pr-carousel-advanced__track .initCarousel.swiper') ||
      root.querySelector('.initCarousel.swiper') ||
      root.querySelector('.swiper');

    if (!inner) return;

    initPrCarouselSwiper(inner, { ...opts, rootEl: root });
  });
});